<template>
<div class="container-fluid">
    <div class="card animated fadeIn">
        <!-- <pre>debug: {{account_opts}} </pre> -->
        <b-row>
            <b-col sm=8>
                <b-card border-variant="light">
                    <div slot="header">
                        <strong>System:</strong>
                        <!--   <pre>Data: {{$data}}</pre><pre>changed: {{changed}}</pre>  -->
                    </div>
                    <div>
                        <b-form @submit.stop.prevent="onSubmit">
                            <b-form-group label="Device Name:" label-for="device_name" :label-cols-sm="4" class="w-50">
                                <b-form-input type="text" v-model="device.name" v-validate.initial="''" id="device_name" name="Device Name" class="form-control" :class="{'is-invalid': submitted && verrors.has('Device Name') }" :readonly=!readonly></b-form-input>
                                <div v-if="submitted && verrors.has('Device Name')" class="invalid-feedback">{{ errors.first('Device Name') }}</div>
                            </b-form-group>

                            <b-form-group label="Password:" label-for="device_password" :label-cols-sm="4" class="w-50">
                                <b-form-input type="text" v-model="device.config.root_password" v-validate.initial="''" id="device_password" name="Device password" class="form-control" :class="{'is-invalid': submitted && verrors.has('Device Name') }" :readonly=!readonly></b-form-input>
                                <div v-if="submitted && verrors.has('Device Password')" class="invalid-feedback">{{ errors.first('Device Password') }}</div>
                            </b-form-group>

                            <b-form-group label="DHCP Client Hostname:" label-for="device_hostname">
                                <b-form-input type="text" v-model="device.config.system.system[0].hostname" v-validate.initial="''" id="device_hostname" name="Device Hostname" class="form-control" :class="{'is-invalid': submitted && verrors.has('Device Hostname') }" :readonly=!readonly></b-form-input>
                                <div v-if="submitted && verrors.has('Device Hostname')" class="invalid-feedback">{{ errors.first('Device Hostname') }}</div>
                            </b-form-group>

                            <b-form-group label="Account:" label-for="device_account_id" :label-cols-lg="3" v-if="Object.keys(account_opts).length > 0">
                                <b-form-select key="account" v-model="device.account_id" :options="account_opts" v-validate="'required'" id="device_account_id" name="Account ID" value-field="id" text-field="name" :readonly=!readonly>
                                </b-form-select>
                            </b-form-group>

                            <!--                 <b-form-group label="Device Password:" label-for="device_pass">
                  <b-form-input type="text" v-model="device.name" v-validate.initial="''" id="device_pass" name="Device Password" class="form-control" :class="{'is-invalid': submitted && verrors.has('Device Password') }"    
                  :append-icon="value ? 'visibility' : 'visibility_off'" 
                  @click:append="() => (value = !value)"
                  :type="value ? 'password' : 'text'"
                  ></b-form-input>
                  <div v-if="submitted && verrors.has('Device Password')" class="invalid-feedback">{{ errors.first('Device Password') }}</div>
                </b-form-group> -->

                            <div class="text-center">
                                <!-- TODO only activate when dirty -->
                                <button v-if="readonly" :disabled="verrors.any()" class="btn btn-primary">Save</button>
                                <!--  <b-button type="reset" variant="danger">Reset</b-button> -->
                                <!-- <button @click.prevent="reRender">Reset</button> -->
                            </div>
                        </b-form>
                    </div>
                </b-card>
            </b-col>
            <b-col sm=4>
                <b-card border-variant="light">
                    <div slot="header">
                        <strong>Tasks</strong>
                    </div>
                    <Tasks :device="device" :changed="changed" :changes="changes"></Tasks>
                </b-card>
            </b-col>
        </b-row>
    </div>
</div>
</template>

<script>
import { ValidationProvider, extend } from 'vee-validate';
import Multiselect from 'vue-multiselect';
import Vue from 'vue';
import Tasks from "@/readynet/devices/network/Tasks";

export default {
    components: {
        ValidationProvider,
        Multiselect,
        Tasks,
    },
    props: {
        device: {
            type: Object,
            required: true,
        },
        account_opts: {
            type: Object,
            default: function () {
                return {}
            }
        },
        changed: {
            type: Array,
        },
        changes: {
            type: Object,
        },
    },

    data() {
        return {
            loading: false,
            submitted: false,

        }
    },

    methods: {

        mounted() {},
        updateChanged(par, val, nam) {
            for (var i = this.changed.length - 1; i >= 0; i--) {
                if (this.changed[i].param === par) {
                    this.changed.splice(i, 1);
                }
            }
            this.changed.push({ param: par, value: val, name: nam })
            this.$set(this.changes, par, val)
        },

        onSubmit() {
            this.submitted = true;
            // console.log("Invalid " + (this.$validator.fields).map(field => field.flags.invalid))
            // console.log("Dirty " + (this.$validator.fields).map(field => field.flags.dirty))
            // console.log("IP dirty " + this.veeFields['LAN IP'].dirty);
            // console.log("netmask dirty " + this.veeFields['LAN Netmask'].dirty);

            // Object.keys(this.veeFields).every(field => {
            //   if (this.veeFields[field].dirty) {
            //     console.log("MSG:", this.veeFields[field] + " ", field)

            //   }
            // });

            this.$validator.validate().then(valid => {

                if (valid) {
                    // need to simplify this
                    if (this.veeFields['Device Name'].dirty) {
                        this.updateChanged("device_name", this.device.name, "Device Name")
                    }
                    if (this.veeFields['Device Hostname'].dirty) {
                        this.updateChanged("device_hostname", this.device.config.system.system[0].hostname, "Device Hostname")
                    }
                    if (this.veeFields['Account ID'].dirty) {
                        this.updateChanged("device_account_id", this.account_opts[this.device.account_id], "Device Account")
                    }

                    // this.$router.push("/#/devices");
                } else {
                    console.log("LAN submitted, INVALID");
                }
            });
        },

    }, // end methods
    computed: {
        readonly() {
            return this.$can('device','edit')
        }
    },
};
</script>
// isFormValid () { // // loop over all contents of the fields object and check if they exist and valid or valid == null. // return Object.keys(this.veeFields).every(field => { // return this.veeFields[field] && (this.veeFields[field].valid || (this.veeFields[field].valid == null)); // }); // } // toArray(obj_obj) { // return Object.keys(obj_obj).map(i => obj_obj[i]); // }, // computed:{ // local: { // get() { // return this.params // }, // set(val) { // // this.$emit('input', val) // } // }, // }, // watch:{ // params:{ // // deep: true, // handler(){ // this.my = this.params // } // }, // },
